import { IconNameEnum } from "@b2bportal/core-themes";

export const useCvvIconName = () => IconNameEnum.cvv;
